import React, { useContext, useEffect, useState } from "react";
import { Box, FormControl, Grid, TextField, Typography } from "@mui/material";
import styles from "./components.module.scss";
import { AppData } from "../../../context/context";

const AgeRequirement = ({
  uniqueKey = "",
  cardView = [],
  eligibilityData = [],
  handleInputChange,
  error = null,
}) => {
  const { formMode, jobConfigMode } = useContext(AppData);

  /* Other states */

  const [mode, setMode] = useState("");

  /* UseEffects */

  useEffect(() => {
    if (uniqueKey === "jobConfig") {
      setMode(jobConfigMode);
    } else {
      setMode(formMode);
    }
  }, [uniqueKey, jobConfigMode]);

  return cardView?.map((ele, id) =>
    ele.type === "textbox" ? (
      <Grid
        key={id}
        item
        sx={{
          flex: "0 0 49%",
          maxWidth: "49%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            rowGap: "10px",
          }}
        >
          <Typography className={`${styles.formFont}`}>
            <span style={{ fontSize: "14px" }}>{ele.title}</span>
          </Typography>
          {uniqueKey === "jobConfig" && mode === "view" ? (
            <div
              className={`${styles.textBoxView} ${styles.textBoxViewDisable}`}
              style={{
                padding: !eligibilityData[ele.valueKey] ? "24px" : "16px 24px",
              }}
            >
              {eligibilityData[ele.valueKey]}
            </div>
          ) : uniqueKey === "eligibilityCriteria" ? (
            <div>
              <FormControl variant="outlined" sx={{ width: "100%" }}>
                <TextField
                  fullWidth
                  id="outlined-adornment-weight"
                  aria-describedby="outlined-weight-helper-text"
                  className={styles.textComponent}
                  placeholder={ele.placeHolder}
                  value={eligibilityData[ele.valueKey]}
                  onChange={(e) => {
                    handleInputChange(e, ele.id);
                  }}
                  inputProps={{
                    "aria-label": "weight",
                  }}
                />
              </FormControl>
              {!!error?.ageError.flag &&
                ((ele.id === 1 && error?.ageError.message.fromAge) ||
                  (ele.id === 2 && error?.ageError.message.toAge)) && (
                  <div
                    className={styles.errorText}
                    style={{ marginTop: "8px" }}
                  >
                    {ele.id === 1
                      ? error.ageError.message.fromAge
                      : error.ageError.message.toAge}
                  </div>
                )}
            </div>
          ) : (
            ""
          )}
        </Box>
      </Grid>
    ) : ele.type === "answer-box" &&
      uniqueKey === "jobConfig" &&
      (!eligibilityData?.fromAge || !eligibilityData?.toAge) ? null : (
      <Grid key={id} item xs={12}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            rowGap: "40px",
          }}
        >
          {ele.type === "header" ? (
            <Typography
              className={`${styles.formFont} flexDisplayColumn`}
              style={{
                rowGap: "17px",
                alignItems: "flex-start",
              }}
            >
              <span className="fontWeight500">{ele.title}</span>
              <span
                className={`${styles.greydedText}`}
                style={{ fontSize: "14px" }}
              >
                {ele.placeHolder}
              </span>
            </Typography>
          ) : (
            <Typography
              className={`${styles.textBoxView} ${styles.blueBackground}`}
              style={{ color: "#1C4980" }}
            >
              <span>{ele.title}:</span>
              {!!eligibilityData?.fromAge && !!eligibilityData?.toAge && (
                <span
                  style={{ marginLeft: "9px", fontWeight: 600 }}
                >{`${eligibilityData?.fromAge} - ${eligibilityData?.toAge} Years`}</span>
              )}
            </Typography>
          )}
        </Box>
      </Grid>
    )
  );
};

export default AgeRequirement;
